export default "__VITE_ASSET__KGMHhu7B__";